<template>
  <div id="home">

    <div v-if="!loading" class="content-warp">
      <div style="width: 100%; height: 30px"></div>
      <div class="div_video_warp">

        <div class="video_placeholder" :style="{height:video_height+'px'}">
          <layVideo :height="video_height" :src="playersrc" :poster="poster"></layVideo>
        </div>
        <div class="video_info">
          <div class="video_info-title">
            {{data.realname}}
          </div>
          <div class="video_info-desc-warp">
            <div class="video_info-desc" v-html="TextAreaText2Html(data.intro)"  @click="alert(data.intro)"></div>
          </div>

        </div>
      </div>



      <div class="scroll-x video-year">
        <div class="scroll-x-item " :class="{active:item==currentCategory}" v-for="item in catalog_category" @click="setCurrentCategory(item)">{{item}}</div>
      </div>
      <div class="scrollView"  @scroll="elementScroll($event)">

        <div class="video-more-warp">
          <div class="left-img-list">
            <div class="left-img-list-item" v-for="(item,index) in catalog_list" @click.stop="play_item(item)" :class="{active:current_vid==item.v_id}">
              <div class="news-list-item-row">
                <img v-if="item.thumb"  v-lazy="item.thumb+'?x-oss-process=image/resize,m_lfit,h_360,w_380'" :style="{width:w+'px'}" class="news-list-item-img news-list-item-img-left" >
                <div class="news-list-item-row-left">
                  <div class="news-list-item-title text-overflow" v-html="item.title"></div>

                  <div class="news-list-item-date">


                    <span>{{item.publish_time}}</span>

                  </div>
                </div>


              </div>

            </div>
          </div>
        </div>

        <!--        <div class="lanmu_title" >-->
        <!--            <div class="lanmu_title_line"></div>-->
        <!--            <span>更多栏目</span>-->
        <!--            <img src="../../../image/r_icn.png">-->
        <!--        </div>-->

        <!--        <div class="lanmu_item_videos scroll-x">-->
        <!--            <div class="lanmu_item_videos_item scroll-x-item" :style="{width:item_width+'px'}"  v-for="item in catalog_list">-->
        <!--                <img :src="item.thumb+'?x-oss-process=image/resize,m_lfit,h_880,w_'+(item_width*4)" class="lanmu_item_videos_item_poster" :style="{width:item_width+'px',height:item_height+'px'}">-->
        <!--                <div class="lanmu_item_videos_item_b ">-->
        <!--                    <div class="lanmu_item_title text-overflow-one">{{item.movie_name}}</div>-->
        <!--                    <div class="lanmu_item_desc text-overflow">{{item.movie_desc}}</div>-->
        <!--                </div>-->
        <!--            </div>-->

        <!--        </div>-->






      </div>



    </div>

    <div class="c-loading" v-if="loading">
      <div class="c-loading-c">
        <img src="../assets/loading.svg">
        <div>加载中...</div>
      </div>

    </div>

  </div>
</template>

<script>
  // @ is an alias to /src
  import request from "../utils/request";
  import utils from "../utils";
  import layVideo from '@/components/Video.vue'

  export default {
    name: 'videoProgramContent',
    components: {
      layVideo
    },
    mounted(){
      var w = document.getElementById("home").offsetWidth;
      this.item_width = parseInt((w-30)/3.2);
      this.item_height=((w-30)/3.2)/(3/4)
      this.video_height=w/(16/9);
      this.w = (w-30)/3
    },
    created() {
      // document.querySelector(".toplink").style.display = 'none';
      this.getdata();
      document.querySelector(".toplink").style.display = 'block';
    },
    data(){
      return {
        id:this.$route.params.id,
        item_width:400,
        item_height:300,
        video_height:200,
        loading:true,
        page:1,
        catalog_category:[],
        currentCategory:'',
        catalog_list:[],
        current_vid:'',
        playersrc:"",
        poster:"",
        w:100,
        firstload:true
      }
    },
    methods:{
      alert:function(info){
        alert(info)
      },
      TextAreaText2Html: function TextAreaText2Html(text) {
        return utils.TextAreaText2Html(text);
      },
      getdata(){
        var _this5 = this;


        var page = this.page;
        this.page = this.page +  1;

        var requestParams = {
          movie_numbers_id:this.id,
          page:page
        };
        if(this.currentCategory){
          requestParams.category_year = this.currentCategory
        }



        request.movie_numbers_personal(requestParams, function (res, err) {
          _this5.loading = false;
          if( err && res.message){
            APP.alert(res.message)
          }
          console.log(res);
          if (err) {
            console.log(err);
          } else if (res && res.code == 200) {
            _this5.data = res.data;

            _this5.loading = false;

            _this5.catalog_category = res.data.catalog_category;
            if(page==1){
              _this5.catalog_list = res.data.catalog_list;
            }else{

              _this5.catalog_list = utils.arrayDelRepeat(_this5.catalog_list.concat(res.data.catalog_list), 'mn_article_id');
            }


            try {


              if(_this5.firstload){
                _this5.firstload = false;
                _this5.currentCategory =res.data.catalog_category[0];
                setTimeout(function () {

                  if(res.data.catalog_list.length>0){
                    _this5.current_vid = res.data.catalog_list[0].v_id
                    request.getVideo(res.data.catalog_list[0].v_id,function (video_res) {

                      _this5.playersrc = video_res.data.path;
                      _this5.poster = video_res.data.cover_url
                    })
                  }else{
                    console.log(JSON.stringify( res.data.catalog_list))
                  }

                }, 500);
              }



              request.getWeixinShanre(location.href,(s_res)=>{
                let {appId,timestamp,nonceStr,signature,thumb} = s_res.data;
                thumb = _this5.data.head_img+'?x-oss-process=image/resize,m_lfit,h_100,w_100';

                let shareconfig = {appId,timestamp,nonceStr,signature};
                if(utils.is_weixin()){
                  if(res.data){
                    let sharedata = {
                      title:res.data.realname,
                      desc:res.data.intro?res.data.intro:"看度时政",
                      link:location.href,
                      imgUrl:thumb
                    };
                    utils.setWeiXinShare(sharedata,shareconfig,false)
                  }

                }
              });

              // api.setWinAttr({
              //     slidBackEnabled: false
              // });

              _this5.$forceUpdate();
            } catch (e) {
              console.log(e);
            }
          } else {
            console.log('qingqiu');
          }
        });
      },
      getdata1(refresh){
        var _this5 = this;


        var page = this.page;
        this.page = this.page +  1;

        var requestParams = {
          movie_id:this.id,
          page:page,

        };
        if(this.currentCategory){
          requestParams.category_year = this.currentCategory
        }



        request.lanmu_content(requestParams, function (res, err) {
          _this5.showloading = false;
          if( err && res.message){
            APP.alert(res.message)
          }
          //console.log(JSON.stringify(res));
          if (err) {
            console.log(err);
          } else if (res && res.code == 200) {
            _this5.loading = false
            _this5.data = res.data

            _this5.showloading = false;

            _this5.catalog_category = res.data.catalog_category;
            if(page==1){
              _this5.catalog_list = res.data.catalog_list;
            }else{

              _this5.catalog_list = utils.arrayDelRepeat(_this5.catalog_list.concat(res.data.catalog_list), 'movie_id');
            }


            try {


              if(_this5.firstload){
                _this5.firstload = false;
                _this5.currentCategory =res.data.catalog_category[0];
                _this5.poster = res.data.catalog_list[0].thumb
                if(res.data.catalog_list.length>0){
                  _this5.current_vid = res.data.catalog_list[0].v_id
                  request.getVideo(res.data.catalog_list[0].v_id,function (video_res) {

                    //openplayer(75,video_res.data,api.winWidth/(16/9),res.data.catalog_list[0].thumb,true)
                    _this5.playersrc = video_res.data.path;
                    _this5.poster = video_res.data.cover_url

                  })
                }else{
                  console.log(JSON.stringify( res.data.catalog_list))
                }





              }

              // api.setWinAttr({
              //     slidBackEnabled: false
              // });

              _this5.$forceUpdate();
            } catch (e) {
              console.log(e);
            }
          } else {
            console.log('qingqiu');
          }
        });
      },
      setCurrentCategory:function(currentCategory){
        if(this.currentCategory === currentCategory){
          return
        }
        this.currentCategory = currentCategory;
        this.page = 1;
        this.showloading = true;
        this.catalog_list = [];
        this.getdata()

      },
      play_item:function(item){
        if(this.current_vid == item.v_id){
          return
        }
        this.current_vid = item.v_id;
        request.getVideo(item.v_id, (video_res)=> {

          this.playersrc = video_res.data.path

        })

      },
      elementScroll: function elementScroll(e) {
        var _this2 = this;

        this.scrolltop = e.target.scrollTop; //滚动到了底部
        if(this.specsub_imgthumb){
          var opactiy = e.target.scrollTop/100;
          if(opactiy<0){
            opactiy = 0
          }else if(opactiy>1){
            opactiy = 1
          }
          this.header_opactiy = opactiy;
        }
        if (this.scrollbottom) {
          var topheight = e.target.offsetHeight + e.target.scrollTop;

          if (topheight + 30 >= e.target.scrollHeight && this.lastscroll < e.target.scrollTop) {
            if (this.scrollTopTimeOut) {
              clearTimeout(this.scrollTopTimeOut);
              this.scrollTopTimeOut = false;
            }
            this.scrollTopTimeOut = setTimeout(function () {
              _this2.scrollbottom();
            }, 300);
          }
          this.lastscroll = e.target.scrollTop;
        }
      },
      scrollbottom: function scrollbottom() {
        this.getdata();
      },
    }
  }
</script>
<style scoped>
  @import '../assets/css/listcomponentscss.css';
  .div_video_warp{ background-image: url("../assets/videl_lanmu_list.png"); background-size: 100% 100%; background-repeat: no-repeat; padding-bottom: 10px}
  .video_placeholder{ width: 100%}
  .video_info{ padding:10px 15px; color: #fff}
  .video_info-title{ padding: 0 10px; background-image: url(../assets/shanjiao_while.png); background-repeat: no-repeat; background-position:0 6px; background-size:10px;
    font-size: 16px; font-weight: bold; line-height: 24px;}
  .video_info-desc{ font-size: 14px; line-height: 24px; text-align: justify;padding: 0 10px;}
  .video-year{ position: relative; border-radius: 10px; background-color: #fff; top:-10px; padding-bottom:5px; color: #fff; padding-top: 15px; width: 100%}
  .video-year .scroll-x-item{ padding: 0 5px; margin-left: 10px; font-size: 16px; line-height: 24px; position: relative; height: 24px; border-radius: 15px;color: #000;}
  .video-year .scroll-x-item:last-child{ margin-right: 10px}
  .video-year .scroll-x-item.active{color: #c22024; background-color: #eaeaea; font-weight: bold}


  .lanmu_item_videos_item{ margin-left: 10px;  background-color: #fff; margin-bottom: 10px}
  .lanmu_item_videos .lanmu_item_videos_item:first-child{ margin-left: 15px;}
  .lanmu_item_videos_item_poster{ width: 100%; height: 220px; object-fit: cover; border-radius: 6px;  box-shadow:0 0 5px rgba(0,0,0,0.4) }
  .lanmu_item_videos_item_b{ padding: 2px 8px; height: 55px}
  .lanmu_item_title{ font-size: 12px; font-weight: bold; line-height: 18px; height: 18px;overflow: hidden;word-break: break-all; width: 100%}
  .lanmu_item_desc{ font-size: 12px; color:#7b7b7b; line-height: 14px;height: 28px;white-space:normal;}
  .lanmu_item{ margin-bottom: 20px; padding-bottom: 20px; border-bottom: 1px solid #fff}
  .video_info-desc-warp{ max-height: 48px; overflow-y: scroll}
  .left-img-list-item.active .news-list-item-title{ color: red}

  .content-warp{height: 100vh; display: flex; flex-direction: column}


</style>
